import React from 'react';
import { useTranslation } from 'react-i18next';
import { EXAM_TYPE } from '../../../../routes/ExamRoute';
import Instructions from './Instructions';

const NonNationalAeisTypeExam = ({
  examType,
  examTitle,
  path,
}: {
  examType: string;
  examTitle: string;
  path: string;
}) => {
  const { t } = useTranslation();

  return (
    <Instructions
      instructionTitle={
        examType === EXAM_TYPE.AEIS
          ? t('exam->>IndividualRegistration.InstructionsForAEIS')
          : t('exam->>IndividualRegistration.InstructionsForSAEIS')
      }
      examType={examType}
      examTitle={examTitle}
      path={path}
    />
  );
};
export default NonNationalAeisTypeExam;
